module.exports = ":host form {\n  -ms-flex: 1;\n      flex: 1;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/education/steps/medical/medical-education-screen.component.scss
// module id = 1428
// module chunks = 0